var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.66791 15.1359L13.478 5.03595C13.9025 4.49129 14.0534 3.8616 13.9119 3.22044C13.7893 2.63756 13.4309 2.08335 12.8932 1.66292L11.5821 0.62139C10.4408 -0.286365 9.02588 -0.190812 8.21469 0.850717L7.33746 1.98876C7.22427 2.13113 7.25257 2.34135 7.39406 2.45601C7.39406 2.45601 9.6107 4.2333 9.65786 4.27152C9.80878 4.41485 9.92197 4.60596 9.95027 4.83528C9.99743 5.28438 9.68616 5.70482 9.22397 5.76215C9.00702 5.79082 8.7995 5.72393 8.64858 5.59971L6.31875 3.74598C6.20556 3.66094 6.03578 3.67909 5.94145 3.79375L0.404567 10.9602C0.046132 11.4093 -0.0764907 11.9922 0.046132 12.556L0.75357 15.6232C0.7913 15.7857 0.932788 15.9003 1.10257 15.9003L4.2153 15.8621C4.78125 15.8526 5.30947 15.5946 5.66791 15.1359ZM10.0264 14.1808H15.1021C15.5973 14.1808 16.0001 14.5888 16.0001 15.0904C16.0001 15.593 15.5973 16.0001 15.1021 16.0001H10.0264C9.53124 16.0001 9.12847 15.593 9.12847 15.0904C9.12847 14.5888 9.53124 14.1808 10.0264 14.1808Z",
    fill: "#2246DC"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit_icon.b01beaaeafbb4ce554cb9df84f1b530a.svg";
export { ForwardRef as ReactComponent };